import { Loader } from '@googlemaps/js-api-loader';
export const API_KEY = 'AIzaSyCaHyI03L0yPG35i2PdoMQdr5gQZFuB2eA';
export async function load() {
    try {
        // Check for existing SDK.
        if (window.google) {
            return window.google;
        }
        // Load the Google JS SDK.
        const googleApiLoader = new Loader({ apiKey: API_KEY });
        const googleApi = await googleApiLoader.load();
        return googleApi;
    }
    catch (error) {
        console.error(error);
        throw error;
    }
}
export async function reverseGeocode(location) {
    try {
        // Load the Google JS SDK.
        const googleApi = await load();
        // Geocode the coordinates to the location string.
        const geocoder = new googleApi.maps.Geocoder();
        const result = await geocoder.geocode({ location });
        return result;
    }
    catch (error) {
        console.error(error);
        return null;
    }
}
export async function geocode(address) {
    try {
        // Load the Google JS SDK.
        const googleApi = await load();
        // Geocode the coordinates to the location string.
        const geocoder = new googleApi.maps.Geocoder();
        const result = await geocoder.geocode({ address });
        return result;
    }
    catch (error) {
        console.error(error);
        return null;
    }
}
